const DefaultLayout = () => import('~/views/layouts/Default')

const Members = () => import('~/views/members/Index')

const Login = () => import('~/views/auth/Login')
const Logout = () => import('~/views/auth/Logout')

/**
 * Path               View                      Name            Component Alias       Description
 * examples           examples/Index.vue        examples        Examples              display a list/table of all examples | the main "example" page
 * examples/create    examples/CreateEdit.vue   example.create  ExampleCreateEdit     return an HTML form for creating a new example | a create page for the "example"
 * examples/:id/edit  examples/CreateEdit.vue   example.edit    ExampleCreateEdit     return an HTML form for editing a example | an edit page for the "example"
 */
export default [
    {
        path: '/login',
        name: 'login',
        meta: {
            guest: true
        },
        component: Login
    },
    {
        path: '/logout',
        name: 'logout',
        component: Logout
    },
    {
        path: '/',
        name: 'home',
        meta: {
            title: 'label.home',
            requiresAuth: true
        },
        component: DefaultLayout,
        children: [
            {
                path: 'dashboard',
                name: 'dashboard',
                meta: {
                    title: 'label.dashboard',
                    showInMenu: true,
                    showInBreadcrumb: true,
                    requiresAuth: true,
                    icon: 'mdi-home'
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
            },
            {
                path: 'members',
                // name: 'members',
                meta: {
                    title: 'label.member',
                    showInMenu: true,
                    showInBreadcrumb: false,
                    requiresAuth: true,
                    icon: 'mdi-account-group-outline'
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: '',
                        name: 'members.index',
                        meta: {
                            title: 'label.member',
                            showInMenu: true,
                            showInBreadcrumb: true,
                            requiresAuth: true
                        },
                        component: Members,
                    },
                    // {
                    //     path: ':id/edit',
                    //     meta: {title: 'Edit Member'},
                    //     name: 'member.edit',
                    //     component: MemberCreateEdit,
                    //     props: true
                    // },
                    // {
                    //     path: 'create',
                    //     meta: {title: 'Create Member'},
                    //     name: 'member.create',
                    //     component: MemberCreateEdit,
                    // }
                ]
            }
        ]
    }
]